import React, { useState } from "react";
import { Layout, Button } from 'antd';
import LimitTrialCard from "./LimitTrialCard";

const ParentPage = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  return (
    <Layout>
      {/* Other content of the page */}

      <Button onClick={togglePopup}>Show Limit Trial Card</Button>

      {isPopupVisible && (
        <div className="popup-container">
          <LimitTrialCard onClose={togglePopup} />
        </div>
      )}
    </Layout>
  );
};

export default ParentPage;
